import { useEffect, useState } from "react";
import { CalendarClock, Loader2, XCircle } from "lucide-react";
import Dialogo from "../sms/Dialogo";
import { waApi } from "./modelos";

const quandoBr = (ag) => (ag ? `${ag.slice(8, 10)}/${ag.slice(5, 7)} às ${ag.slice(11, 16)}` : "");

/**
 * Campanhas de WhatsApp agendadas que ainda não saíram, com Cancelar (o valor
 * reservado volta pra carteira). Some quando não há nenhuma.
 */
export default function AgendadasWhatsApp() {
  const [lista, setLista] = useState([]);
  const [cancelando, setCancelando] = useState(null);
  const [trabalhando, setTrabalhando] = useState(false);
  const [erro, setErro] = useState(null);

  const carregar = () => waApi.agendadas().then(setLista).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const cancelar = async () => {
    setTrabalhando(true);
    try {
      const r = await waApi.cancelar(cancelando.id);
      if (!r?.success) setErro(r?.erro || "Não deu pra cancelar.");
      setCancelando(null);
      carregar();
    } finally { setTrabalhando(false); }
  };

  if (!lista.length) return null;
  return (
    <div className="rounded-xl border border-t-2 border-t-amber-500 bg-card p-5">
      <h3 className="mb-3 flex items-center gap-2 font-semibold">
        <CalendarClock className="h-4 w-4 text-amber-500" /> Agendadas
      </h3>
      <ul className="divide-y">
        {lista.map((c) => (
          <li key={c.id} className="flex items-center gap-3 py-2.5 text-sm">
            <span className="flex-1 min-w-0 truncate font-medium">{c.nome}</span>
            <span className="text-muted-foreground tabular-nums">{quandoBr(c.agendada_para)}</span>
            <span className="text-muted-foreground tabular-nums">{c.total_destinatarios} cliente{c.total_destinatarios === 1 ? "" : "s"}</span>
            <button type="button" onClick={() => setCancelando(c)}
              className="rounded-lg border px-3 py-1 text-xs font-semibold hover:bg-muted">Cancelar</button>
          </li>
        ))}
      </ul>
      {erro && <p className="mt-2 text-sm text-destructive">{erro}</p>}
      {cancelando && (
        <Dialogo icone={XCircle} tom="alerta" titulo="Cancelar o agendamento?" onFechar={() => setCancelando(null)}
          acoes={[{ rotulo: "Voltar", onClick: () => setCancelando(null) },
            { rotulo: trabalhando ? "Cancelando…" : "Cancelar campanha", primario: true, onClick: cancelar, desabilitado: trabalhando }]}>
          <p className="text-center">
            <b>{cancelando.nome}</b> ({quandoBr(cancelando.agendada_para)}) não vai sair, e o valor reservado volta pra carteira.
          </p>
          {trabalhando && <Loader2 className="mx-auto mt-2 h-4 w-4 animate-spin" />}
        </Dialogo>
      )}
    </div>
  );
}
